import ApiService from "../ApiService";

const countryService = {
    getCountries() {
        return ApiService.get(`/country/`);
    }
};

export default countryService;